"use client";
import React, { useState } from "react";
import "./Specifications.css";
import { motion, AnimatePresence } from "framer-motion";

function Specifications({ specifications }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // 🔥 stagger container
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  // 🔥 item animation
  const item = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      className="bellevue-specifications-wrapper"
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
    >
      <div className="section-padding">
        <div className="main-container">
          <div className="flex-row j-c-sb specifiction-flex inner-flex-tab">
            <motion.div className="section-title" variants={item}>
              <h2
                className="specification-title"
                style={{ textTransform: "capitalize" }}
              >
                Specifications
              </h2>
            </motion.div>

            <motion.div className="inner-flex" variants={container}>
              {specifications.map((itemData, index) => (
                <motion.div
                  key={index}
                  className="specifications-accordian-box flex-row alc j-c-sb"
                  onClick={() => toggleAccordion(index)}
                  style={{ cursor: "pointer" }}
                  variants={item}
                >
                  <div className="inner-flex w100">
                    <div className="flex-row alc j-c-sb w100">
                      <div className="section-content">
                        <p style={{ color: "#00000" }} className="medium-fonts">
                          {itemData.title}
                        </p>
                      </div>
                      <div className="accor-icon">
                        <span
                          className="material-symbols-outlined"
                          style={{ color: "#00000" }}
                        >
                          {activeIndex === index ? "remove" : "add"}
                        </span>
                      </div>
                    </div>

                    {/* 🔥 Animated Accordion Content */}
                    <AnimatePresence initial={false}>
                      {activeIndex === index && (
                        <motion.div
                          className="bel-spe-accordion-show-text link-font-size active"
                          // initial={{ height: 0, opacity: 0 }}
                          // animate={{ height: "auto", opacity: 1 }}
                          // exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.4, ease: "easeInOut" }}
                          // style={{ overflow: "hidden" }}
                        >
                          {/* <p>{itemData.description}</p> */}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: itemData.description,
                            }}
                          />
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Specifications;
